<div style="position: relative;">
    <div [ngClass]="{'sidebar-closed': is_close_sidebar_menu}">
        <app-topbar-sidebar [is_close_sidebar_menu]="is_close_sidebar_menu"
            (is_close_sidebar_menuChange)="is_close_sidebar_menu = $event"></app-topbar-sidebar>
    </div>

    <app-menu-sidebar [is_close_sidebar_menu]="is_close_sidebar_menu"
        (is_close_sidebar_menuChange)="is_close_sidebar_menu = $event">
    </app-menu-sidebar>
</div>


<div class="container_fixed_backgroud" *ngIf="!is_close_sidebar_menu"></div>